var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[(_vm.$vuetify.breakpoint.smAndUp)?_c('h3',[_vm._v(_vm._s(_vm.title))]):(_vm.$vuetify.breakpoint.xsOnly)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('v-spacer'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }